const Footer = () => (
  <div className="iris-footer">
    <p>
      By messaging iRis, you agree to our{" "}
      <a
        href="https://example.com/terms"
        target="_blank"
        rel="noopener noreferrer">
        Terms
      </a>{" "}
      and{" "}
      <a
        href="https://example.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  </div>
);

export default Footer;
